import { type JSX } from 'react';

import { createFileRoute } from '@tanstack/react-router';

import { LearningPathOverviewPage } from '@/features/learning-path/pages/LearningPathOverviewPage';
import { requireAccess } from '@/permissions';

export const Route = createFileRoute('/trilha-de-aprendizagem/$id')({
  staticData: { title: 'Acompanhamento de trilha' },
  beforeLoad: requireAccess('view:learning_path'),
  component: LearningPathOverviewRoute,
});

function LearningPathOverviewRoute(): JSX.Element {
  const { id } = Route.useParams();
  const learningPathId = Number(id);

  if (!Number.isInteger(learningPathId) || learningPathId <= 0) {
    throw new Error('Invalid learning path id');
  }

  return <LearningPathOverviewPage learningPathId={learningPathId} />;
}
